module.exports = __webpack_public_path__ + "img/0Q3A6963_L_WoodMatted.2c4c9f3b.jpg";